import { useTranslation } from 'hooks/useTranslation'
import Head from 'next/head'
import Script from 'next/script'
import { Footer } from '../../components/Footer'
import { Header } from '../../components/Header'
import { Layout } from '../../components/Layout'
import { Bubblehouse } from '../../features/Bubblehouse'
import React from 'react'

export default function ReferralDetailPage() {
  const { t } = useTranslation()
  const bubblehouseShopSlug =
    process.env.NEXT_PUBLIC_ENV === 'staging' ? 'we-feed-raw-test' : 'we-feed-raw'
  console.log('bubblehouseShopSlug', bubblehouseShopSlug)
  const header = <Header />
  return (
    <div>
      <Head>
        <title>{t('referrals:page-title')}</title>
        <meta name="title" content={t('referrals:meta-title')} />
        <meta name="description" content={t('referrals:meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/refer-a-friend" />
      </Head>
      <Script src={`https://app.bubblehouse.com/s/${bubblehouseShopSlug}/bubblehouse.js`} />
      <main>
        <Layout header={header} hideCTA={true}>
          <Bubblehouse bubblehouseShopSlug={bubblehouseShopSlug} />
          <Footer />
        </Layout>
      </main>
    </div>
  )
}
